import { useNavigate } from 'react-router-dom';

import { Dropdown, Menu } from '@arco-design/web-react';
import CommonLogoMenuItemIcon from '@dmp/assets/icons/common-logo-menu-item.svg?react';
import DatasetManagementIcon from '@dmp/assets/icons/dataset-management.svg?react';
import LogoMenuIcon from '@dmp/assets/icons/logo-menu.svg?react';
import RbacIcon from '@dmp/assets/icons/rbac.svg?react';
import { ROUTE_PATHS } from '@dmp/constant/routePaths';
import { useGlobalStore } from '@dmp/stores/globalStore';
import { isRbacAdminFromToken, isRbacEnabled } from '@dmp/utils/rbac';
import clsx from 'clsx';

import './LogoDropdown.css';
import { LogoDropdownKey } from './LogoDropdown.types';

export const LogoDropdown = () => {
  const navigate = useNavigate();
  const internalAppPermission = useGlobalStore((s) => s.internalAppsPermission);

  const isDatasetManagementDisabled = !internalAppPermission.dataset_management;
  const isTelemetryDashboardDisabled = !internalAppPermission.telemetry;
  // RBAC is not a JWT `internal_apps` entry like the other two — it is the platform-wide
  // RBAC Administrator grant. So this item is hidden outright rather than shown disabled, and the
  // condition is the same one InternalAppsGuard's 'rbac' case and Portal's RBAC card use; anything
  // looser would offer a link that lands on NoPermission.
  const canManageRbac = isRbacEnabled() && isRbacAdminFromToken();

  const dropList = (
    <Menu>
      <Menu.Item
        key={LogoDropdownKey.DatasetManagement}
        onClick={() => navigate(ROUTE_PATHS.INTERNAL_APP_DATASET_MANAGEMENT_DASHBOARD)}
        disabled={!internalAppPermission.dataset_management}
      >
        <span
          className={clsx(
            'inline-flex items-center justify-center w-[50px] h-[50px] rounded-[6px]',
            isDatasetManagementDisabled ? 'bg-[#ccc]' : 'bg-[#7A54D9]'
          )}
        >
          <DatasetManagementIcon stroke="#FFF" />
        </span>
        <span className={clsx('text-[14px]', isDatasetManagementDisabled ? 'text-[#ccc]' : 'text-[#000]')}>
          Dataset Management
        </span>
      </Menu.Item>

      <Menu.Item
        key={LogoDropdownKey.TelemetryDashboard}
        onClick={() => navigate(ROUTE_PATHS.INTERNAL_APP_TELEMETRY)}
        disabled={isTelemetryDashboardDisabled}
      >
        <span
          className={clsx(
            'inline-flex items-center justify-center w-[50px] h-[50px] rounded-[6px]',
            isTelemetryDashboardDisabled ? 'bg-[#ccc]' : 'bg-[#7A54D9]'
          )}
        >
          <CommonLogoMenuItemIcon stroke="#FFF" />
        </span>
        <span className={clsx('text-[14px]', isTelemetryDashboardDisabled ? 'text-[#ccc]' : 'text-[#000]')}>
          Telemetry Dashboard
        </span>
      </Menu.Item>

      {canManageRbac && (
        <Menu.Item key={LogoDropdownKey.Rbac} onClick={() => navigate(ROUTE_PATHS.INTERNAL_APP_RBAC)}>
          <span className="inline-flex items-center justify-center w-[50px] h-[50px] rounded-[6px] bg-[#7A54D9]">
            <RbacIcon stroke="#FFF" />
          </span>
          <span className="text-[#000] text-[14px]">RBAC</span>
        </Menu.Item>
      )}

      <Menu.Item key={LogoDropdownKey.DataMarketPlace} onClick={() => navigate(ROUTE_PATHS.DATA_CATALOG)}>
        <span className="inline-flex items-center justify-center w-[50px] h-[50px] rounded-[6px] bg-[#7A54D9]">
          <CommonLogoMenuItemIcon />
        </span>
        <span className="text-[#000] text-[14px]">Data Marketplace</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown droplist={dropList} trigger="click" triggerProps={{ className: 'logo-dropdown-popup' }}>
      <span className="cursor-pointer">
        <LogoMenuIcon />
      </span>
    </Dropdown>
  );
};
